import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Dialog } from "@toddle-edu/ds-web";

const TEST_ID_PREFIX = "transcriptsV3-gradeLevels";

const UnsavedChangesDialog = ({ isOpen, onDiscard, onSave, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      title={t("common:discard_changes")}
      onButtonOneClick={onDiscard}
      onButtonTwoClick={onSave}
      testId={`${TEST_ID_PREFIX}-discard`}
      message={t("transcript:unsaved_changes_message")}
      variant="confirm-dialog"
      onClose={onClose}
      buttonOneText={t("common:discard")}
      buttonTwoText={t("common:save_changes")}
    />
  );
};

UnsavedChangesDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default memo(UnsavedChangesDialog);
